
import { Inbox } from "lucide-react";

const EmptyPendingRequestsState = () => (
  <div className="text-center py-10 text-redflags-gray">
    <Inbox className="w-8 h-8 mx-auto mb-3 text-redflags-light" />
    <p>No pending requests</p>
  </div>
);

export default EmptyPendingRequestsState;
